export default __webpack_public_path__ + "static/7_35-b1aab1e9d45f535e54e4569b696b845b.png";